<template>
  <div id="international-payment-redirect-page">
    <vs-alert color="danger" :title="$t('InvoiceGroupNotifyTitle')" :active.sync="not_found">
      <span>{{ $t('InvoiceGroupNotifyDesc') }}</span>
    </vs-alert>
  </div>
</template>

<script>
import Vue from "vue";
import InvoiceApi from "@/api/invoice";
import { VueReCaptcha } from "vue-recaptcha-v3";

Vue.use(VueReCaptcha, { siteKey: process.env.VUE_APP_GOOGLE_CAPTCHA });

export default {
  components: {},
  data() {
    return {
      not_found: false
    };
  },
  methods: {
    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        scale: 0.45
      });

      const groupId = this.$route.params.groupId;

      var invoiceResult = await InvoiceApi.prepeareInvoice(
        { InvoiceSettingsGroupKey: groupId.toString() },
        this
      );

      if (!invoiceResult.data.error && invoiceResult.data.redirect) {
        this.$router.push({
          name: "international-payment",
          params: { invoiceId: invoiceResult.data.redirect }
        });
      } else this.not_found = true;

      setTimeout(() => {
        this.$vs.loading.close();
      }, 100);
    }
  },
  created() {},
  mounted() {
    this.fetchLoadData();
  }
};
</script>
